import { useEffect, useState } from "react";

/** The URL once it has really loaded (preloaded via `Image`); null while loading, on error or without a URL. */
export function useLoadedImage(url: string | undefined): string | null {
  const [loaded, setLoaded] = useState<string | null>(null);
  useEffect(() => {
    if (!url) {
      setLoaded(null);
      return;
    }
    let live = true;
    const img = new Image();
    img.onload = () => live && setLoaded(url);
    img.onerror = () => live && setLoaded(null);
    img.src = url;
    return () => {
      live = false;
    };
  }, [url]);
  return loaded === url ? url : null;
}
